import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as DOCImportedSVG } from "src/assets/icons/doc-svg.svg";
import { ReactComponent as FolderImportedSVG } from "src/assets/icons/folder-svg.svg";
import { ReactComponent as JPGImportedSVG } from "src/assets/icons/jpg-svg.svg";
import { ReactComponent as MOVImportedSVG } from "src/assets/icons/mov-svg.svg";
import { ReactComponent as PDFImportedSVG } from "src/assets/icons/pdf-svg.svg";
import { ReactComponent as PNGImportedSVG } from "src/assets/icons/png-svg.svg";
import { ReactComponent as TXTImportedSVG } from "src/assets/icons/txt-svg.svg";
import { ReactComponent as XLSImportedSVG } from "src/assets/icons/xls-svg.svg";

// import {
//     Document,
//     DocumentFields,
//     FileBaseInsert,
//     FileBaseInsertFields,
//     FileBaseInsertRequired
// } from "src/types/files/filesData";
import { groupBy } from "../helpers";
import { EntityWithIdFields } from "../../types/baseEntities";

const getExtensionFile = (descFile: string): string => {
    return descFile.slice((descFile.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
}

// export const getFormDataFileInsert = (fileBase: FileBaseInsert, file: File): FormData => {
//     const formData: FormData = new FormData();

//     formData.append(FileBaseInsertFields.DocumentId, fileBase[FileBaseInsertFields.DocumentId].toString());
//     formData.append(FileBaseInsertFields.FileSize, fileBase[FileBaseInsertFields.FileSize].toString());
//     formData.append(FileBaseInsertFields.HasPhysicalFile, fileBase[FileBaseInsertFields.HasPhysicalFile]?.toString() || 'false');
//     formData.append(FileBaseInsertFields.File, file, fileBase[FileBaseInsertFields.FileDesc]);
//     formData.append(FileBaseInsertFields.Private, fileBase[FileBaseInsertFields.Private]?.toString() || 'false');
//     formData.append(FileBaseInsertFields.IdProfile, fileBase[FileBaseInsertFields.IdProfile]?.toString() || '');
//     fileBase[FileBaseInsertFields.SharedWith]?.map((empresa) => formData.append(FileBaseInsertFields.SharedWith, empresa.toString()))

//     return formData;
// }

// export const getFormDataFileInsertRequired = (fileBase: FileBaseInsertRequired, file: File): FormData => {
//     const formData: FormData = new FormData();

//     formData.append(FileBaseInsertFields.DocumentId, fileBase[FileBaseInsertFields.DocumentId].toString());
//     formData.append(FileBaseInsertFields.FileSize, fileBase[FileBaseInsertFields.FileSize].toString());
//     formData.append(FileBaseInsertFields.HasPhysicalFile, fileBase[FileBaseInsertFields.HasPhysicalFile]?.toString() || 'false');
//     formData.append(FileBaseInsertFields.Required, fileBase[FileBaseInsertFields.Required]?.toString() || 'false');
//     formData.append(FileBaseInsertFields.File, file, fileBase[FileBaseInsertFields.FileDesc]);

//     return formData;
// }

// export const getFormDataSimpleFileInsert = (fileBase: FileBaseInsert, file: File): FormData => {
//     const formData: FormData = new FormData();

//     formData.append(FileBaseInsertFields.File, file, fileBase[FileBaseInsertFields.FileDesc]);

//     return formData;
// }

export const fileFormatter = {
    getIconClassByNameFile: (descFile: string): string => {
        switch (getExtensionFile(descFile)) {
            case "xls":
            case "xlsx":
                return "fa fa-2x fa-file-excel text-success";
            case "pdf":
                return "fa fa-2x fa-file-pdf text-danger";
            case "docx":
                return "fa fa-2x fa-file-word text-primary";
            case "jpg":
            case "jpeg":
            case "png":
                return "far fa-2x fa-file-image text-black";
            default:
                return "fa fa-2x fa-file-alt text-black";
        }
    },

    getIconByFileName: (fileName: string, props: SvgIconProps = {}) => {
        switch (getExtensionFile(fileName)) {
            case "pdf":
                return (
                    <SvgIcon component={PDFImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'txt':
                return (
                    <SvgIcon component={TXTImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'xls':
            case 'xlsx':
                return (
                    <SvgIcon component={XLSImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'doc':
            case 'docx':
                return (
                    <SvgIcon component={DOCImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'jpeg':
            case 'jpg':
                return (
                    <SvgIcon component={JPGImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'bmp':
            case 'png':
                return (
                    <SvgIcon component={PNGImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            case 'mp3':
            case 'mp4':
            case 'mkv':
                return (
                    <SvgIcon component={MOVImportedSVG} viewBox="0 0 384 512" {...props} />
                )
            default:
                return (
                    <SvgIcon viewBox="0 0 1024 1024" {...props}>
                        <path
                            d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z" />
                    </SvgIcon>
                )

        }
    },

    getIconFolder: (props: SvgIconProps = {}) => {
        return (
            <SvgIcon component={FolderImportedSVG} viewBox="0 0 384 512" {...props} />
        );
    },

    // groupByDocumentId: (files: Document[]): Document[] => {
    //     const filesByDocument = groupBy(files, [EntityWithIdFields.Id]);
    //     const finalDocuments: Document[] = [];

    //     Object.values(filesByDocument).forEach(docs => {
    //         finalDocuments.push({
    //             ...docs[0],
    //             [DocumentFields.NumberFiles]: docs.length
    //         });
    //     });

    //     return finalDocuments;
    // }
};
